import styled from "styled-components";

const Alert = styled.div`
  display: flex;
  padding: 8px 10px;
  font-size: 1rem;
  font-weight: 300;
  justify-content: center;
  align-items: center;
  border: 1px solid #eeeeee;
  background-color: #fcfcfc;
`;

export default Alert;
